<template>
    <v-col>
      <v-row>
        <h3 v-if="tableTitle" class="pb-1">{{ tableTitle }}</h3>
      </v-row>
      <v-row>
        <v-simple-table :class="tableClasses">
          <template v-slot:default>
            <thead>

            <tr v-if="headers.length">
              <th v-for="(label, headerName) in headers" :key="headerName">
                <slot
                    :name="'header-' + headerName"
                    :label="label"
                    :headerName="headerName"
                >
                  {{ label }}
                </slot>
              </th>
            </tr>

            <tr class="v-data-table__progress" v-if="loading">
              <th colspan="3" class="column">
                <v-progress-linear indeterminate absolute />
              </th>
            </tr>
            </thead>
            <tbody v-if="!loading">
              <tr v-for="(row, rowIndex) in rows" :key="rowIndex">
                <td v-for="(label, columnName) in row" :key="columnName" :class="'column--' + columnName">
                  <slot
                      :name="'column-' + columnName"
                      :label="label"
                      :columnName="columnName"
                      :row="row"
                      :rowIndex="rowIndex"
                  >
                    {{ label }}
                  </slot>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-row>
    </v-col>
</template>

<script>


export default {
  name: "SimpleTable",
  props : {
    headers: {
      type: Array,
      default :  () => []
    },
    rows: {
      type: Array,
      default :  () => []
    },
    tableTitle: {
      type: [String, null],
      default :  () => null
    },
    tableElevation : {
      type: [Number, null],
      default : () => 0
    },
    loading : {
      type: Boolean,
      default : () => false
    },
    tableModifierClasses: {
      type: Array,
      default :  () => []
    },
  },
  computed : {
    tableClasses() {
      let classes = 'simple-table';

      if (this.tableElevation !== null) {
        classes += ' ' + 'elevation-' + this.tableElevation;
      }

      for (let i=0; i<this.tableModifierClasses.length; i++) {
        classes += ' simple-table--' + this.tableModifierClasses[i];
      }

      return classes;
    }
  },
};
</script>

<style lang="scss">
.simple-table {
  font-family: Roboto, sans-serif;
  font-weight: 400;

  table > thead > tr > th,
  table > tbody > tr > td {
    font-size: 1rem !important;
    line-height: 1.6 !important;
  }

  // Table modifier - dss
  &--dss {
    .v-data-table__progress {
      height: 6px !important;
    }
    &.v-data-table > .v-data-table__wrapper > table {
      > thead, > tbody {
        > tr {
          td:first-child, th:first-child {
            padding-left: 0;
          }
        }
      }
    }
  }

  // Table modifier - full-width
  &--full-width {
    &.v-data-table{
      width: 100%;
    }
  }
}
</style>